export enum PropertyDetailsSentResponse {
  Undecided = 0,
  Interested = 1,
  NotInterested = 2,
}
